import React from 'react';

import MobileProductFilterWrapper from './MobileProductFilterWrapper';
import TypeRefinementList from './TypeRefinementList';

const MobileProductFilters = ({ items, refine }) => (
  <div>
    <MobileProductFilterWrapper id="type" label="Type">
      <TypeRefinementList items={items} refine={refine} />
    </MobileProductFilterWrapper>
  </div>
);

export default MobileProductFilters;
